export enum PostMessageAction {
  APP_LOADED = 'app-loaded',
  CURRENT_STEP_CHANGED = 'current-step-changed',
  PRODUCT_TYPE_SELECTED = 'product-type-selected',
  PRODUCT_TYPE_DISMISSED = 'product-type-dismissed',
  STEPS_COMPLETED = 'steps-completed',
  REDIRECTED_TO = 'redirected-to',
  ERROR = 'error'
}

export const sendMessage = <T>(action: PostMessageAction, data: T) => {
  const event = { source: 'product-manager', action, data };

  if ((window as any)?.ReactNativeWebView?.postMessage) {
    (window as any)?.ReactNativeWebView?.postMessage(JSON.stringify(event));
    return;
  }

  top?.postMessage(event, '*');
};

export const redirectTo = (url: string, actionId: string) => {
  sendMessage(PostMessageAction.REDIRECTED_TO, { url, actionId });
  window.open(url, '_self');
};
